import { createStore } from '@orderx/lab/xr/store';
import { AppCache, useAppCacheAutoSync } from '../services/app-cache';

type Store = {
    tagIdsClaimed: number[];
    orderIdContactFormHandled: {
        [orderId: number]: boolean;
    };
};

const { useStore } = createStore<Store>(
    Object.assign(
        {
            tagIdsClaimed: [],
            orderIdContactFormHandled: {},
        } as Store,
        AppCache.get('userSession'),
    ),
);

export function useUserSession() {
    const [state, setState] = useStore();

    useAppCacheAutoSync('userSession', state);

    return {
        tagIdsClaimed: state.tagIdsClaimed,
        claimTagId(tagId: number) {
            setState((state) => {
                if (!state.tagIdsClaimed.includes(tagId)) {
                    state.tagIdsClaimed.push(tagId);
                }
            });
        },
        isOrderIdContactFormHandled(orderId: number) {
            return Boolean(state.orderIdContactFormHandled[orderId]);
        },
        setIsOrderIdContactFormHandled(orderId: number, isHandled: boolean) {
            setState((state) => {
                state.orderIdContactFormHandled[orderId] = isHandled;
            });
        },
    };
}
